__webpack_require__.p = "https://beta.sg.safer.whs.amazon.dev/";